export default __webpack_public_path__ + "static/media/settings-white.e7eaba8f.svg";